/**
 * teamColors.js
 * 
 * Team colours, in the order teams are created. A room can have up to 10 teams.
 */

export const teamColors = [
    { key: "red",      name: "Red",    bg: "bg-red",      text: "text-black" },
    { key: "yellow",   name: "Yellow", bg: "bg-yellow",   text: "text-black" },
    { key: "blue",     name: "Blue",   bg: "bg-blue",     text: "text-black" },
    { key: "green",    name: "Green",  bg: "bg-green",    text: "text-black" },
    { key: "black",    name: "Black",  bg: "bg-zinc-600", text: "text-white" },
    { key: "pink",     name: "Pink",   bg: "bg-pink",     text: "text-black" },
    { key: "lavender", name: "Purple", bg: "bg-lavender", text: "text-black" },
    { key: "peach",    name: "Orange", bg: "bg-peach",    text: "text-black" },
    { key: "aqua",     name: "Aqua",   bg: "bg-aqua",     text: "text-black" },
    { key: "mint",     name: "Mint",   bg: "bg-mint",     text: "text-black" },
];

export const MAX_TEAMS = teamColors.length;

/**
 * A team's colour (teams from before colours were stored are matched by name, e.g. "Team Red")
 * @param {Object} team     -   Team
 * @returns {Object}        -   Entry from teamColors
 */
export const getTeamColor = (team) =>
    teamColors.find((color) => color.key === team?.color) ||
    teamColors.find((color) => team?.name?.toLowerCase().endsWith(color.name.toLowerCase())) ||
    teamColors[4];

/**
 * Teams in the order they were created
 * @param {Array} teams     -   Teams
 * @returns {Array}         -   Sorted copy
 */
export const sortTeams = (teams) =>
    [...teams].sort((a, b) =>
        (a.order ?? teamColors.indexOf(getTeamColor(a))) - (b.order ?? teamColors.indexOf(getTeamColor(b)))
    );
